import React from 'react';
import PaymentList from '../components/PaymentList';

function Payments() {
  // PaymentList が <Box sx={{p:3}}> + <PageHeader title="外注先支払管理" /> を内包しているため、
  // ここでは薄いラッパとして PaymentList をそのまま返すだけにする (タイトル二重表示防止)
  return <PaymentList />;
}

export default Payments;
